module.exports = __webpack_public_path__ + "img/af.6675ee7b.png";